import { render, staticRenderFns } from "./customBadge.vue?vue&type=template&id=33ae6b06&scoped=true"
import script from "./customBadge.vue?vue&type=script&lang=js"
export * from "./customBadge.vue?vue&type=script&lang=js"
import style0 from "./customBadge.vue?vue&type=style&index=0&id=33ae6b06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ae6b06",
  null
  
)

export default component.exports